import React from 'react';
import {ReactComponent as Logo} from '../../assets/svgs/logo.svg';
import {Link} from "react-router-dom";

function HeaderLogo() {
    return (
        <Link to={"/"}>
            <div className={"h-12 flex flex-row items-center"}>
                <Logo/>
            </div>
        </Link>
    );
}

export default HeaderLogo;